<template>
  <v-card id="promotion-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-btn
          color="primary"
          class="me-3"
          :disabled="hasNotPermission('Permissions.UserCreate')"
          @click="createDialogShow()"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Добавить</span>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск..."
          class="promotion-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>
    <v-data-table
      :headers="headers"
      :items="users"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      class="text-no-wrap"
    >
      <template #[`item.userName`]="{item}">
        {{ item.userName }}
      </template>
      <template #[`item.email`]="{item}">
        {{ item.email }}
      </template>
      <template #[`item.initials`]="{item}">
        {{ item.initials }}
      </template>
      <template #[`item.role`]="{item}">
        {{ item.role }}
      </template>
      <template #[`item.isActive`]="{item}">
        <v-chip
          small
          :color="color(item.isActive)"
          :class="`${color(item.isActive)}--text`"
        >
          {{ getString(item.isActive) }}
        </v-chip>
      </template>
      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center justify-center">
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="18">
                  {{ icons.mdiDotsVertical }}
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :disabled="hasNotPermission('Permissions.UserCreate')"
                href="javascript:void(0)"
                @click="roleDialogShow(item)"
              >
                <v-list-item-title>
                  <v-icon
                    size="18"
                    :disabled="hasNotPermission('Permissions.UserCreate')"
                    class="me-2"
                  >
                    {{ icons.mdiAccountCogOutline }}
                  </v-icon>
                  <span>Сменить роль</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="hasNotPermission('Permissions.UserCreate')"
                href="javascript:void(0)"
                @click="passwordDialogShow(item)"
              >
                <v-list-item-title>
                  <v-icon
                    size="18"
                    :disabled="hasNotPermission('Permissions.UserCreate')"
                    class="me-2"
                  >
                    {{ icons.mdiLockReset }}
                  </v-icon>
                  <span>Сменить пароль</span>
                </v-list-item-title>
              </v-list-item>
              <v-divider class="my-1"></v-divider>
              <v-list-item
                :disabled="hasNotPermission('Permissions.UserBlock') || !item.isActive"
                href="javascript:void(0)"
                @click="blockPopupShow(item.id, item.userName)"
              >
                <v-list-item-title>
                  <v-icon
                    size="18"
                    :disabled="hasNotPermission('Permissions.UserBlock')"
                    class="me-2"
                  >
                    {{ icons.mdiBlockHelper }}
                  </v-icon>
                  <span>Заблокировать</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="hasNotPermission('Permissions.UserActivate') || item.isActive"
                href="javascript:void(0)"
                @click="activatePopupShow(item.id, item.userName)"
              >
                <v-list-item-title>
                  <v-icon
                    size="18"
                    :disabled="hasNotPermission('Permissions.UserActivate')"
                    class="me-2"
                  >
                    {{ icons.mdiAccountReactivate }}
                  </v-icon>
                  <span>Активировать</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
    <delete-dialog
      ref="blockPopup"
      :label="deleteLabel"
      @delete-confirmed="blockUser"
    />
    <delete-dialog
      ref="activatePopup"
      :label="activateLabel"
      @delete-confirmed="activateUser"
    />
    <user-form
      :show="createDialog"
      :cancellation="createDialogCancel"
    ></user-form>
    <user-role-dialog
      :show="roleDialog"
      :user-id="selected.id"
      :user-name="selected.userName"
      :role="selected.role"
      :cancellation="roleDialogCancel"
    ></user-role-dialog>
    <user-password-dialog
      :show="passwordDialog"
      :user-id="selected.id"
      :user-name="selected.userName"
      :cancellation="passwordDialogCancel"
    ></user-password-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  mdiTrendingUp,
  mdiPlus,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiEyeOutline,
  mdiPencilOutline,
  mdiBlockHelper,
  mdiAccountReactivate,
  mdiAccountCogOutline,
  mdiLockReset,
} from '@mdi/js'
import { mapFormHandlers } from '@/helpers/forms'
import DeleteDialog from '@/components/delete-dialog'
import UserForm from './user-form'
import UserRoleDialog from './user-role-dialog'
import UserPasswordDialog from './user-password-dialog'
import { hasPermission } from '@/helpers'

export default {
  name: 'UserList',
  components: {
 DeleteDialog, UserForm, UserRoleDialog, UserPasswordDialog,
},
  data: () => ({
    createDialog: false,
    roleDialog: false,
    passwordDialog: false,
    selected: { id: 0, userName: '', role: '' },
    icons: {
      mdiTrendingUp,
      mdiPlus,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiDotsVertical,
      mdiEyeOutline,
      mdiBlockHelper,
      mdiAccountReactivate,
      mdiAccountCogOutline,
      mdiLockReset,
    },
    deleteLabel: '',
    activateLabel: '',
    deleteMethod: null,
  }),
  computed: {
    ...mapFormHandlers('user', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('user', {
 users: 'list', totalCount: 'totalCount', loading: 'loading', searchQuery: 'searchQuery',
}),
    headers() {
      return [
        { text: 'Логин', value: 'userName' },
        { text: 'Почта', value: 'email' },
        { text: 'Инициалы', value: 'initials' },
        { text: 'Роль', value: 'role' },
        { text: 'Статус', value: 'isActive' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Пользователи'
    await this.fetchUsers()
  },
  methods: {
    ...mapActions('user', { fetchUsers: 'fetchList', blockUser: 'block', activateUser: 'activate' }),
    blockPopupShow(id, name) {
      this.deleteLabel = `Пользователь ${name} будет заблокирован.`
      this.$refs.blockPopup.open(id)
    },
    createDialogShow() {
      this.createDialog = true
    },
    hasNotPermission(val) {
      return !hasPermission(val)
    },
    createDialogCancel() {
      this.createDialog = false
    },
    roleDialogShow(user) {
      this.selected = { id: user.id, userName: user.userName, role: user.role }
      this.roleDialog = true
    },
    roleDialogCancel() {
      this.roleDialog = false
    },
    passwordDialogShow(user) {
      this.selected = { id: user.id, userName: user.userName, role: user.role }
      this.passwordDialog = true
    },
    passwordDialogCancel() {
      this.passwordDialog = false
    },
    activatePopupShow(id, name) {
      this.activateLabel = `Пользователь ${name} будет активирован.`
      this.$refs.activatePopup.open(id)
    },
    getString(isActive) {
      return isActive ? 'Активный' : 'Заблокирован'
    },
    color(isActive) {
      return isActive ? 'success' : 'error'
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
